import lazyGettext from 'js-utils/lazy-gettext';
import { makeValidator } from 'eventbrite_design_system/utils/validation/validation';
import {
    makeHasMaxLength,
    makeHasMinLength,
    isProvided,
} from 'js-utils/validators';

export const collectionForm = makeValidator({
    name: [
        {
            validator: isProvided,
            errorMessage: lazyGettext(
                'Please enter a name for the collection.',
            ),
        },
        {
            validator: makeHasMaxLength(255),
            errorMessage: lazyGettext(
                'Collection name must be less than 255 characters.',
            ),
        },
    ],
    summary: [
        {
            validator: makeHasMaxLength(1000),
            errorMessage: lazyGettext(
                'Collection summary must be less than 1000 characters.',
            ),
        },
    ],
    eventsToRemove: [
        {
            validator: makeHasMinLength(1),
            errorMessage: lazyGettext(
                'Must select at least one event to delete.',
            ),
        },
    ],
});
